import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
  li {
    font-weight: 300;
    font-size: large;
  }
  b {
    font-weight: 600;
  }
`;

const InstructionsCoding = ({ codingRound }) => {
  return (
    <Wrap>
      <ul>
        <li>
          <b>Codeforces account is mandatory.</b> If you don't have an account
          on codeforces, create it ASAP -{" "}
          <a
            href="https://codeforces.com/register"
            target={"_blank"}
            style={{ color: "white", textDecoration: "underline" }}
          >
            codeforces.com
          </a>
          .<br />
          Make sure to use the same email which you have used to register on
          know-your-prep.
        </li>
        <br />
        <li>
          <b>Fill the Google form</b> -{" "}
          <a
            href={codingRound.googleForm}
            target={"_blank"}
            style={{ color: "white", textDecoration: "underline" }}
          >
            {codingRound.googleForm}
          </a>
          <br /> Make sure to use the same email which you have used to register
          on codeforces.
        </li>
        <br />
        <li>
          <b>Register for the contest. </b>Visit{" "}
          <a
            href={codingRound.codeforcesInvitation}
            target={"_blank"}
            style={{ color: "white", textDecoration: "underline" }}
          >
            here
          </a>{" "}
          and click on Register.
        </li>
        <br />
        <li>
          Contest will start on <b>{codingRound.date}</b> at{" "}
          <b>{codingRound.startTime}</b> and end at <b>{codingRound.endTime}</b>
        </li>
        <br />
        <li>Login 10 min before start time.</li>
      </ul>
    </Wrap>
  );
};

export default InstructionsCoding;
